export const webErrorsToIgnore = [
  'AbortError',
  'ResizeObserver loop completed with undelivered notifications',
  'ResizeObserver loop limit exceeded',
  'Non-Error promise rejection captured with keys',
  "Failed to execute 'measure' on 'Performance'",
  'Request failed with status code 401',
  "No mark named 'beforeRender' exists",
  'Cancel rendering route',
  'Request aborted',
  'Non-Error promise rejection captured with value',
  "Can't find variable: EmptyRanges",
];

export const apiErrorsToIgnore = [
  'ForbiddenError',
  'PreconditionRequiredError',
  'UnauthorizedError',
  'PaymentRequiredError',
  'ConflictError',
  'Request failed with status code',
  'The sign in failed or was canceled',
  'BadRequestError',
  'This coupon is not valid',
  'Your card was declined. This transaction requires authentication',
];
